"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarksideSmugglersUnion = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const SelectColony_1 = require("../../inputs/SelectColony");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class DarksideSmugglersUnion extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.DARKSIDE_SMUGGLERS_UNION,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.SPACE],
            cost: 17,
            tr: { moonLogistics: 1 },
            metadata: {
                cardNumber: 'M80',
                description: 'Raise the Logistics Rate 1 step.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Perform a trade action.', (ab) => {
                        ab.empty().startAction.trade();
                    }).br;
                    b.br;
                    b.moonLogisticsRate();
                }),
            },
        });
    }
    ;
    canAct(player) {
        const openColonies = player.game.colonies.filter((colony) => colony.isActive && colony.visitor === undefined);
        return openColonies.length > 0 && player.getFleetSize() > player.tradesThisGeneration;
    }
    action(player) {
        const openColonies = player.game.colonies.filter((colony) => colony.isActive && colony.visitor === undefined);
        const coloniesModel = player.game.getColoniesModel(openColonies);
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => new SelectColony_1.SelectColony('Select colony tile to trade with for free', 'Select', coloniesModel, (colonyName) => {
            openColonies.forEach((colony) => {
                if (colony.name === colonyName) {
                    player.game.log('${0} traded with ${1}', (b) => b.player(player).colony(colony));
                    colony.trade(player);
                    return undefined;
                }
                return undefined;
            });
            return undefined;
        })));
        return undefined;
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        MoonExpansion_1.MoonExpansion.raiseLogisticRate(player);
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonLogisticsRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.DarksideSmugglersUnion = DarksideSmugglersUnion;
//# sourceMappingURL=DarksideSmugglersUnion.js.map